import React from 'react';

import PropertyResponses from './Components/PropertyResponses';
import { Alert } from '@knockrentals/knock-react';
import * as VirtualAgentAPI from '../VirtualAgentAPI';
import { useFeatureFlagContext } from '../../../Context/FeatureFlagContext';
import { makeStyles, Text } from '@knockrentals/knock-shared-web';
import { RenterAIDisclaimerMessage } from './utils';

const useStyles = makeStyles({
  disclaimerText: {
    marginTop: '25px',
    marginBottom: '25px',
    marginRight: '30%',
    fontWeight: 400,
    fontSize: '20px',
    lineHeight: 'normal',
  },
});

const VirtualAgentLeasingResponses = ({
  properties,
  intents,
  onConfirmation,
  currentTab
}) => {
  const classes = useStyles();
  const { renterAIFlag } = useFeatureFlagContext();
  const renterAIProperties = renterAIFlag?.properties || [];
  const renterAIDisclaimerMessage = renterAIProperties.length ? 
  RenterAIDisclaimerMessage(properties, renterAIProperties) : '';

  return (
    <React.Fragment>
      {renterAIDisclaimerMessage && (
        <Text variant='h6' className={classes.disclaimerText}>
          {renterAIDisclaimerMessage}
        </Text>
      )}
      {properties.length ? (
        properties.map((property) => (
          <PropertyResponses
            key={property.id}
            property={property}
            intents={intents}
            onConfirmation={onConfirmation}
            getResponses={VirtualAgentAPI.getLeasingResponsesV2}
            saveResponses={VirtualAgentAPI.saveLeasingResponsesV2}
            currentTab={currentTab}
          />
        ))
      ) : (
        <Alert>No properties to display.</Alert>
      )}
    </React.Fragment>
  );
};

export default VirtualAgentLeasingResponses;
